import { render, staticRenderFns } from "./IconSvgPause.vue?vue&type=template&id=7d8b88de&scoped=true&"
import script from "./IconSvgPause.vue?vue&type=script&lang=js&"
export * from "./IconSvgPause.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8b88de",
  null
  
)

export default component.exports